export const memberRoles = {
    roleChanged: 'MEMBER_ROLES.ROLE_CHANGED',
    roleChangeFailed: 'MEMBER_ROLES.ROLE_CHANGE_FAILED',
    makeBillingOwner: 'MEMBER_ROLES.MAKE_BILLING_OWNER',
    billingTitle: 'MEMBER_ROLES.BILLING_TITLE',
    billingDescription: 'MEMBER_ROLES.BILLING_DESCRIPTION',
    billingDone: 'MEMBER_ROLES.BILLING_DONE',
    billingFailed: 'MEMBER_ROLES.BILLING_FAILED',
    billingOnlyOwners: 'MEMBER_ROLES.BILLING_ONLY_OWNERS',
    billingPersonal: 'MEMBER_ROLES.BILLING_PERSONAL',
    billingPaid: 'MEMBER_ROLES.BILLING_PAID',
    billingOwner: 'MEMBER_ROLES.BILLING_OWNER',
    billingHandledBy: 'MEMBER_ROLES.BILLING_HANDLED_BY',
    billingHandledByOwner: 'MEMBER_ROLES.BILLING_HANDLED_BY_OWNER',
    cancel: 'MEMBER_ROLES.CANCEL',
    noAccess: 'MEMBER_ROLES.NO_ACCESS',
    inviteDescription: 'MEMBER_ROLES.INVITE_DESCRIPTION',
    unknownRole: 'WORKSPACE_ROLES.UNKNOWN',
    deletedAccount: 'MEMBER_ROLES.DELETED_ACCOUNT'
};
